var map = {
	"./partner_1.png": 354,
	"./partner_2.png": 355,
	"./partner_3.png": 356,
	"./partner_4.png": 357,
	"./partner_5.png": 358,
	"./partner_6.png": 359,
	"./partner_7.png": 360,
	"./partner_8.png": 361
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 722;